import styled, { css } from 'styled-components';
import { Upload as AntdUpload } from 'antd';
import Icon from '../Icon';
import { Text } from '../Typography';

const { Dragger: AntdDragger } = AntdUpload;

const wrapperMixin = css<{ openFileDialogOnClick?: boolean }>`
  && {
    border: none;
    background-color: transparent;
    cursor: ${({ openFileDialogOnClick }) =>
      openFileDialogOnClick ? 'pointer' : 'initial'};
  }
`;

export const StyledUpload = styled(AntdUpload)`
  ${wrapperMixin}
`;

export const StyledDragger = styled(AntdDragger)`
  ${wrapperMixin}
`;

export const StyledIcon = styled(Icon)`
  margin-bottom: 20px;
`;

export const StyledHeader = styled(Text)`
  font-size: 20px;
  margin: 30px 0px;
`;

export const StyledTitle = styled(Text)`
  font-size: 15px;
  margin-bottom: 5px;
`;

export const StyledDescription = styled(Text)`
  margin-bottom: 15px;
`;
